<!-- Modal -->
@if (visible) {
  <div class="fixed inset-0 z-50 flex items-center justify-center modal-backdrop bg-black bg-opacity-50"
    (click)="onBackdropClick($event)">
    <div class="bg-white rounded-lg shadow-xl mx-6 max-h-[90vh] overflow-hidden flex flex-col w-[60%]"
      (click)="$event.stopPropagation()">
      <!-- Header del modal -->
      <div class="flex justify-between items-center px-12 py-6 ">
        <h3 class="text-xl font-semibold text-gray-800">Agregar a mi registro</h3>
        <button (click)="close()" class="text-gray-500 hover:text-gray-700 transition-colors p-1">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <!-- Contenido del modal -->
      <div class="flex-1 overflow-y-auto">
        @defer (on immediate; prefetch on idle) {
          <app-create-supplier mode="embedded" [directoryItem]="supplierData"></app-create-supplier>
        }
    </div>
  </div>
</div>
}